import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import AccordionComponent from './js/accordion.component';

ComponentsFactory.getInstance().define('accordion', AccordionComponent);
